<template>
    <v-layout pa-0 fill-height>
        <v-flex xs12>
            <v-card>
                <!-- TOOLBAR -->
                <v-toolbar
                        dark
                        color="primary"
                >
                    <v-btn
                            icon
                            dark
                            @click="discardAndExit()"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('account.title') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                                dark
                                flat
                                @click="saveAndExit()"
                        >
                            Save
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-layout row wrap pa-0>
                    <v-flex xs12 md4>
                        <v-card
                                class="ma-2 pa-2 mx-auto text-xs-center"
                                flat
                        >
                            <v-card-text>
                                <v-avatar
                                        size="88"
                                >
                                    <img src="@/assets/img/user/userAvatar.png" alt="avatar"
                                         class="mb-4"
                                    />
                                </v-avatar>
                                <h3 class="headline mb-2">
                                    {{ userInfo.name + " " + userInfo.surname }}
                                </h3>
                                <div v-if="userInfo.username" class="blue--text mb-2">{{ userInfo.username }}</div>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-layout
                                    tag="v-card-text"
                                    text-xs-left
                                    row wrap
                            >
                                <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Role:</v-flex>
                                <v-flex xs5>{{ userInfo.role }}</v-flex>
                                <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Email:</v-flex>
                                <v-flex xs5>{{ userInfo.email }}</v-flex>
                                <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Phone:</v-flex>
                                <v-flex xs5>{{ userInfo.phone }}</v-flex>
                                <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Scenario:</v-flex>
                                <v-flex xs5>{{ userInfo.scenarioId }}</v-flex>

                                <v-flex xs12 pt-4>
                                    <p class="subheading ma-1">
                                        Available scenarios:
                                    </p>
                                    <ScenarioSelection :scenarioList="userInfo.scenarioList"
                                                       :selectedScenarioId="userInfo.scenarioId"
                                                       :scenarioCallback="selectScenario">
                                    </ScenarioSelection>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md8>
                        <v-card flat class="pa-2 ma-2">
                            <p class="subheading mt-2 mb-3">
                                Modify your personal information:
                            </p>
                            <form>
                                <v-text-field
                                        v-model="userInfo.name"
                                        :error-messages="nameErrors"
                                        :counter="50"
                                        label="Name"
                                        required
                                        @input="$v.name.$touch()"
                                        @blur="$v.name.$touch()"
                                ></v-text-field>
                                <v-text-field
                                        v-model="userInfo.surname"
                                        :error-messages="nameErrors"
                                        :counter="50"
                                        label="Surname"
                                        required
                                        @input="$v.name.$touch()"
                                        @blur="$v.name.$touch()"
                                ></v-text-field>
                                <v-text-field
                                        v-model="userInfo.username"
                                        :error-messages="nameErrors"
                                        :counter="50"
                                        label="Username"
                                        required
                                        @input="$v.name.$touch()"
                                        @blur="$v.name.$touch()"
                                ></v-text-field>
                                <v-text-field
                                        v-model="userInfo.email"
                                        :error-messages="emailErrors"
                                        label="E-mail"
                                        required
                                        @input="$v.email.$touch()"
                                        @blur="$v.email.$touch()"
                                ></v-text-field>
                                <v-text-field
                                        v-model="userInfo.phone"
                                        :error-messages="emailErrors"
                                        label="Phone"
                                        required
                                        @input="$v.name.$touch()"
                                        @blur="$v.name.$touch()"
                                ></v-text-field>
                                <v-text-field
                                        v-model="userInfo.password"
                                        :error-messages="nameErrors"
                                        :counter="50"
                                        label="Password"
                                        required
                                        @input="$v.name.$touch()"
                                        @blur="$v.name.$touch()"
                                ></v-text-field>

                                <v-layout row wrap pt-4>
                                    <v-flex class="text-xs-right">
                                        <v-btn flat color="primary" @click="submit">submit</v-btn>
                                        <v-btn flat @click="clear">clear</v-btn>
                                    </v-flex>
                                </v-layout>

                            </form>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {email, maxLength, required} from 'vuelidate/lib/validators'
    import {mapGetters, mapState} from 'vuex';
    import RouterService from "@/helpers/RouterService";
    import StateService from "@/helpers/StateService";
    import ScenarioSelection from "../../components/Scenario/ScenarioSelection";

    export default {
        name: 'AccountManagement',
        components: {ScenarioSelection},
        mixins: [validationMixin],
        validations: {
            name: {required, maxLength: maxLength(50)},
            surname: {required, maxLength: maxLength(50)},
            username: {required, maxLength: maxLength(50)},
            phone: {required, maxLength: maxLength(15)},
            password: {required, maxLength: maxLength(50)},
            email: {required, email},
        },
        data() {
            return {
                name: '',
                surname: '',
                username: '',
                phone: '',
                password: '',
                email: '',
            }
        },
        computed: {
            ...mapState({}),
            ...mapGetters('UserState', {
                    userInfo: 'getUserInfo',
                }
            ),
            nameErrors() {
                const errors = [];
                if (!this.$v.name.$dirty) return errors;
                !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long');
                !this.$v.name.required && errors.push('Name is required.');
                return errors;
            },
            emailErrors() {
                const errors = [];
                if (!this.$v.email.$dirty) return errors;
                !this.$v.email.email && errors.push('Must be valid e-mail');
                !this.$v.email.required && errors.push('E-mail is required');
                return errors;
            },
        },
        created() {
        },
        methods: {
            /**
             * Save or discard (and exit)
             */
            discardAndExit() {
                RouterService.goBack();
            },
            saveAndExit() {
                RouterService.goBack();
            },
            /**
             * Handle temporary Settings
             */
            submit() {
                this.$v.$touch();
            },
            clear() {
                this.$v.$reset();
                this.name = '';
                this.email = '';
                this.select = null;
                this.checkbox = false;
            },
            selectScenario(scenarioId) {
                this.userInfo.scenarioId = scenarioId;
                this.$store.dispatch("UserState/setUserInfo", this.userInfo);
                StateService.resetAllVolatileData();
            }
        }
    }
</script>

<style lang="scss">
</style>
